import { StepZutat } from "@/types/baseTypes";
import { customSanitize } from "@/utils/customSanitize";
import React from "react";
import styles from "./RecipeIngredientTable.module.scss";

function RecipeIngredientTable({
  ingredients,
  hasBorder,
  isSmall = false,
}: {
  ingredients: StepZutat[];
  hasBorder?: boolean;
  isSmall?: boolean;
}) {
  return (
    <div
      role="table"
      className={`${styles.table} table ${isSmall ? styles["small"] : ""}`}
      data-has-border={hasBorder ? "true" : "false"}
    >
      <div role="rowgroup">
        {ingredients?.map((ingredient, idx) => {
          return (
            <div role="row" className={styles.row} key={idx}>
              <div role="cell" className={styles["amount"] + " amount"}>
                <p>{`${
                  ingredient.step_zutat_menge !== 0
                    ? ingredient.step_zutat_menge
                    : ""
                } ${ingredient.step_zutat_masseinheit_abkuerzung}`}</p>
              </div>
              <div role="cell" className={styles["name"]}>
                {ingredient.zutat_namen && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: customSanitize(ingredient.zutat_namen),
                    }}
                  />
                )}
                {/* )} */}
                {ingredient.step_zutat_freitext && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        customSanitize(ingredient.step_zutat_freitext) ?? "",
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RecipeIngredientTable;
